function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { get } from "./getPropertyByPath";
class AnaliticsObject {
  constructor() {
    this.objectParams = {};
    this.objectParamName = '';
    this.params = {};
    this.title = '';
    this.titleArray = [];
  }
}
export const getAnaliticsParamFromArray = (arr, name) => {
  if (arr) {
    return arr.filter(item => {
      return item.name == name;
    });
  }
};
export function handleAnalitics(obj) {
  const el = getAnaliticsParamFromArray(obj.objectParams, obj.objectParamName);
  tealiumClickFunc(tealiumMergeClickData(el ? el[0] : {}, obj.params), obj.title, obj.titleArray);
}
export function tealiumGenerateClickData(jsonData, text) {
  return _objectSpread(_objectSpread(_objectSpread({}, new TealiumData()), jsonData), {}, {
    eventLab: text ? text : jsonData.eventLab
  });
}
export function getLastPartInURL(url) {
  let splitter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\/';
  return url ? url.split(splitter).pop() ? url.split(splitter).pop() : url : '';
}
export function getLinkDomain(url) {
  return url ? url.replace(/(https:\/\/www\.|http:\/\/www\.|www\.|https:\/\/|http:\/\/)/, '') : '';
}
export function replaceInString(replaceId, replaceString, replaceText) {
  return replaceString.replace(replaceId, replaceText);
}
export function tealiumClickCustomFunc(jsonData) {
  let tealiumData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new TealiumData();
  const resObj = tealiumFlatData(jsonData);
  if (typeof window !== 'undefined') {
    const utag = get(window, "utag");
    //if(window) {
    //const {utag} = window as any;
    const utegResultObject = _objectSpread(_objectSpread({}, tealiumData), resObj);
    console.log(utegResultObject);
    if (utag) utag.link(utegResultObject);
  }
}
export function tealiumClickFunc(jsonData, text, textArray) {
  var resObj = tealiumFlatData(jsonData);
  if (typeof window !== 'undefined') {
    const utag = get(window, "utag");
    //if(window) {
    //const {utag} = window as any;

    const utegResultObject = _objectSpread(_objectSpread(_objectSpread({}, new TealiumData()), resObj), {}, {
      eventLab: tealiumFlatDataSetParams(resObj.eventLab, text, textArray)
    });
    const finalObj = {
      event_act: utegResultObject.eventAct,
      event_name: utegResultObject.eventName,
      event_cat: utegResultObject.eventCat,
      event_lab: utegResultObject.eventLab
    };
    if (Object.keys(utegResultObject).includes('email')) {
      finalObj['email'] = utegResultObject.email;
    }
    console.log(finalObj);
    if (utag) {
      utag.link(finalObj);
    }
    //}
  }
}
export function tealiumClickFuncWithOtherOptions(jsonData, text) {
  let otherOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var resObj = tealiumFlatData(jsonData);
  if (typeof window !== 'undefined') {
    const utag = get(window, "utag");
    //if(window) {
    //const {utag} = window as any;

    const utegResultObject = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, new TealiumData()), resObj), otherOptions), {}, {
      eventLab: tealiumFlatDataSetParams(resObj.eventLab, text)
    });
    const finalObj = {
      event_act: utegResultObject.eventAct,
      event_name: utegResultObject.eventName,
      event_cat: utegResultObject.eventCat,
      event_lab: utegResultObject.eventLab,
      login_status: utegResultObject.login_status
    };
    console.log(finalObj);
    if (utag) {
      utag.link(finalObj);
    }
    //}
  }
}
export function tealiumClickFuncExtended(jsonData, text) {
  let additinal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var resObj = tealiumFlatData(jsonData);
  if (typeof window !== 'undefined') {
    const utag = get(window, "utag");
    //if(window) {
    //const {utag} = window as any;
    const utegResultObject = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, new TealiumData()), resObj), additinal), {}, {
      eventLab: tealiumFlatDataSetParams(resObj.eventLab, text)
    });
    console.log({
      event_act: utegResultObject.eventAct,
      event_name: utegResultObject.eventName,
      event_cat: utegResultObject.eventCat,
      event_lab: utegResultObject.eventLab,
      whats_on_event_name: utegResultObject.whats_on_event_name,
      event_venue: utegResultObject.event_venue,
      event_date: utegResultObject.event_date,
      event_type: utegResultObject.event_type
    });
    if (utag) utag.link({
      event_act: utegResultObject.eventAct,
      event_name: utegResultObject.eventName,
      event_cat: utegResultObject.eventCat,
      event_lab: utegResultObject.eventLab,
      whats_on_event_name: utegResultObject.whats_on_event_name,
      event_venue: utegResultObject.event_venue,
      event_date: utegResultObject.event_date,
      event_type: utegResultObject.event_type
    });
    //}
  }
}
export function tealiumFlatData(data) {
  for (let key in data) {
    data[key] = get(data[key], 'jss.value', typeof data[key] == 'object' ? '' : data[key]);
  }
  return data;
}
function tealiumFlatDataSetParams(str, params, paramsArray) {
  var regEXP = new RegExp('\@[a-zA-Z]+\@|\#[a-zA-Z]+\#', "g");
  let counter = -1;
  if (!params) {
    return str;
  } else if (str && str.match(regEXP) && Array.isArray(params)) {
    str = str.replace(regEXP, function (e, i) {
      counter++;
      return params[counter];
    });
    return str;
  } else if (str && str.match(regEXP)) {
    return str.replace(regEXP, params);
  } else {
    return params;
  }
}
export function tealiumCheckRightTextClick(e, analyticsFunction) {
  let value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  let el = e.target;
  if (el && el.tagName === "A" && value) {
    tealiumClickFunc(analyticsFunction, [value, el.text]);
  } else if (el && el.tagName === "A") {
    tealiumClickFunc(analyticsFunction, el.text);
  }
}
export function tealiumMergeClickData(data, params) {
  var resObj = tealiumFlatData(data);
  return _objectSpread(_objectSpread({}, resObj), params);
}
export function tealiumFlatNewData(data) {
  for (let key in data) {
    data[key] = get(data[key], 'jss.value', typeof data[key] == 'object' ? '' : data[key]);
  }
  return data;
}
export function tealiumMergeClickNewData(data, params) {
  var resObj = tealiumFlatNewData(data);
  return _objectSpread(_objectSpread({}, resObj), params);
}
export class TealiumData {
  constructor() {
    this.eventName = '';
    this.eventCat = '';
    this.eventAct = '';
    this.eventLab = '';
  }
}
export class TealiumData__LinkDescription {
  constructor() {
    this.title = '';
    this.context = '';
  }
}